import { Component, Input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleOilRecommendation } from '../vehicle-oil-recommendation/vehicle-oil-recommendation';
import { VehicleBatteryRecommendation } from '../vehicle-battery-recommendation/vehicle-battery-recommendation';
import { VehicleService } from '../../../services/vehicle.service';

@Component({
  selector: 'allas-vehicle-recommendation',
  standalone: true,
  imports: [
    CommonModule,
    VehicleOilRecommendation,
    VehicleBatteryRecommendation,
  ],
  template: `
    @if (hasDefaultVehicle()) { @if (shouldShowOilRecommendation()) {
    <allas-vehicle-oil-recommendation [categoryName]="categoryName" />
    } @else if (shouldShowBatteryRecommendation()) {
    <allas-vehicle-battery-recommendation [categoryName]="categoryName" />
    } @else {
    <!-- Solo mostrar información del vehículo sin recomendaciones específicas -->
    <div class="bg-gray-50 border-t-4 border-appPrimary-500 p-4 xl:p-6 mb-6">
      <!-- Mobile: Layout vertical -->
      <div class="xl:hidden space-y-4">
        <div class="text-center">
          <span class="font-bold text-black uppercase text-sm block mb-3">
            COMPRANDO ACTUALMENTE PARA:
          </span>
          <div
            class="bg-white border-l-4 border-appPrimary-500 px-4 py-3 flex items-center justify-center"
          >
            <span class="text-black font-medium">
              {{ getDefaultVehicle()?.anio }} {{ getDefaultVehicle()?.marca }}
              {{ getDefaultVehicle()?.modelo }} {{ getDefaultVehicle()?.motor }}
            </span>
          </div>
        </div>
        <div class="flex flex-col space-y-2">
          <button
            (click)="clearDefaultVehicle()"
            class="text-black underline text-sm hover:text-gray-700"
          >
            Cambiar Vehículo
          </button>
          <button
            (click)="clearDefaultVehicle()"
            class="text-black underline text-sm hover:text-gray-700"
          >
            Comprar Sin Vehículo
          </button>
        </div>
      </div>

      <!-- Desktop: Layout horizontal -->
      <div class="hidden xl:flex items-center justify-between">
        <div class="flex items-center">
          <span class="font-bold text-black uppercase text-sm mr-4">
            COMPRANDO ACTUALMENTE PARA:
          </span>
          <div
            class="bg-white border-l-4 border-appPrimary-500 px-4 py-3 flex items-center"
          >
            <span class="text-black font-medium">
              {{ getDefaultVehicle()?.anio }} {{ getDefaultVehicle()?.marca }}
              {{ getDefaultVehicle()?.modelo }} {{ getDefaultVehicle()?.motor }}
            </span>
          </div>
        </div>
        <div class="flex flex-col space-y-2">
          <button
            (click)="clearDefaultVehicle()"
            class="text-black underline text-sm hover:text-gray-700"
          >
            Cambiar Vehículo
          </button>
          <button
            (click)="clearDefaultVehicle()"
            class="text-black underline text-sm hover:text-gray-700"
          >
            Comprar Sin Vehículo
          </button>
        </div>
      </div>
    </div>
    } } @else {
    <!-- Mostrar selector de vehículo cuando no hay vehículo seleccionado -->
    <div class="bg-gray-50 border-t-4 border-appPrimary-500 p-4 xl:p-6 mb-6">
      <div class="text-center">
        <h3 class="font-bold text-black uppercase text-lg mb-3">
          SELECCIONA TU VEHÍCULO
        </h3>
        <p class="text-black text-sm mb-4">
          Selecciona tu vehículo para obtener recomendaciones personalizadas
        </p>
        <button
          (click)="showVehicleSelector()"
          class="bg-appPrimary-500 hover:bg-appPrimary-600 text-white px-6 py-2 rounded font-semibold transition-colors"
        >
          Seleccionar Vehículo
        </button>
      </div>
    </div>
    }
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class VehicleRecommendation {
  @Input() categoryName: string = '';

  private vehicleService = inject(VehicleService);

  hasDefaultVehicle = computed(() => {
    return !!this.vehicleService.getDefaultVehicle();
  });

  shouldShowOilRecommendation = computed(() => {
    return this.categoryName.toLowerCase().includes('aceite de motor');
  });

  shouldShowBatteryRecommendation = computed(() => {
    return this.categoryName.toLowerCase().includes('batería');
  });

  getDefaultVehicle() {
    return this.vehicleService.getDefaultVehicle();
  }

  clearDefaultVehicle(): void {
    // Ambos botones hacen lo mismo: quitar el vehículo por defecto
    const vehiculoPorDefecto = this.vehicleService.getDefaultVehicle();

    this.vehicleService.setDefaultVehicle(vehiculoPorDefecto?.id || 0, true);
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    }, 5);
  }

  showVehicleSelector(): void {
    // Aquí puedes implementar la lógica para mostrar el selector de vehículos
    // Por ejemplo, abrir un modal o navegar a la página de selección
    console.log('Mostrar selector de vehículos');
  }
}
